import { useEffect } from 'react';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { TEST_TOGGLE_GB_TIMING } from '@/config/GrowthBook/constants';
import { useSelector } from 'react-redux';

export const GrowthbookTestToggle = () => {
  const summary = useSelector(state => state.summary);
  const isActive = useFeatureIsOn(TEST_TOGGLE_GB_TIMING);

  useEffect(() => {
    if (isActive) {
      // eslint-disable-next-line no-console
      console.log('GrowthbookTestToggle - userId:', summary.id);
    }
  }, [isActive, summary.id]);

  return null;
};
